import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import validid from 'validid';
import Select from 'react-select';
import { Common, PopUpBox } from '../../../components';
import { styles, options, capitalizeName, alphabetOnly, numberWithNoCommas, detectMob, pad, alphabetAndNumberOnly } from '../../../utils/common';
import DropdownIndicator from '../../../components/Common/DropdownIndicator';

import ReloadIcon from '../../../assets/images/reload.svg';
import { actionGetConfig, actionGetStateDoc, actionMoneyForm1 } from '../../../store/application/actions';
import { useDispatch } from 'react-redux';
import { actionApplicationIP } from '../../../store/common/actions';
import moment from 'moment';

function StepForm1({ sessionId, onCompleted }) {
    const dispatch = useDispatch();
    const {
        setValue,
        register,
        handleSubmit,
        getValues,
        setError,
        setFocus,
        formState: { errors, isSubmitting },
    } = useForm();
    const [gender, setGender] = useState(null);
    const [isVisibleInvalidToken, setIsVisibleInvalidToken] = useState(false);
    const [hkid2, setHkid2] = useState('');
    const [checkBoxTime, setCheckBoxTime] = useState({})
    const [captcha, setCaptcha] = useState()
    const [url, setUrl] = useState(null)

    const captchaRandom = () => {
        let originText = [];
        let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (let i = 0; i < 4; i++) {
            let char = possible.charAt(Math.floor(Math.random() * possible.length));
            originText.push(char);
        }
        return originText.join('').toLocaleUpperCase()
    }

    useEffect(() => {
        setCaptcha(captchaRandom())
        getConfigUrl()
    }, [])

    const getConfigUrl = async () => {
        const response = await dispatch(actionGetConfig('MONEY_HERO_URL'));
        if (response?.sts_code === 0) {
            setUrl(JSON.parse(response?.content));
        }
    }

    const onSubmit = async (data) => {
        // check hkid valid
        if (!checkId(data?.hkid1, data?.hkid2, data?.hkid3)) {
            setFocus('hkid3')
            return
        };
        if (data?.captcha_code !== captcha) return;

        const responseDoc = await dispatch(actionGetStateDoc());
        const agree_doc = (responseDoc?.content ?? []).map(doc => {
            return {
                doc_type: doc.doc_type,
                doc_version: doc.doc_ver,
            }
        })
        const responseIP = await dispatch(actionApplicationIP());
        const obj = {
            loan_amount: numberWithNoCommas(data?.loan_amount),
            loan_purpose: data?.loan_purpose,
            first_name: data?.first_name,
            last_name: data?.last_name,
            cust_gender: `0${gender}`,
            hkid: `${data?.hkid1}${data?.hkid2}${data?.hkid3}`,
            date_of_birth: `${data?.date_of_birth3}${pad(data?.date_of_birth2)}${pad(data?.date_of_birth1)}`,
            phone_number: data?.phone_number,
            email: data?.email,
            // education: data?.education,
            // marriage_status: data?.marriage_status,
            application_device: detectMob() ? 2 : 1,
            application_ip: responseIP?.ip,
            application_browser: window.navigator.userAgent,
            hkid_array: [data?.hkid1, data?.hkid2, data?.hkid3],
            check_box_1: data?.checkbox1,
            check_box_2: data?.checkbox2,
            check_box_1_time: moment(checkBoxTime?.check_box_1_time).format('YYYY-MM-DD HH:mm:ss'),
            check_box_2_time: moment(checkBoxTime?.check_box_2_time).format('YYYY-MM-DD HH:mm:ss'),
            agree_doc: JSON.stringify(agree_doc),
            session_id: sessionId
        };
        console.log(obj)
        const response = await dispatch(actionMoneyForm1(obj));
        console.log(response);
        if (response?.sts_code === 0) {
            onCompleted({ status: true, data: { form1: obj } })
        }
    };

    const checkId = (hkid1, hkid2, hkid3) => {
        if (hkid1 && hkid2 && hkid3) {
            return validid.hkid(`${hkid1}${hkid2}/${hkid3}`);
        }
        return false;
    };

    const beforeunload = (e) => {
        // const event = e || window.event;
        // if (event) {
        //     event.returnValue = 'Sure?';
        // }
        // return 'Sure?';
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener('beforeunload', beforeunload);
        return () => {
            window.removeEventListener('beforeunload', beforeunload);
        };
    }, []);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            {isVisibleInvalidToken && <PopUpBox.InvalidToken />}
            <Common.Loading isVisible={isSubmitting} />
            <div className="bg-white lg:px-10">
                <div className="p-3 flex max-md:flex-col">
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl text-gray mb-[18px] font-bold">貸款金額</p>
                        <Common.InputMoney register={register} title="loan_amount" setError={setError} errors={errors} />
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-xl text-gray mb-2 font-bold">貸款目的</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('loan_purpose', { required: true })}
                                onChange={(e) => {
                                    setValue('loan_purpose', e.value);
                                    setError('loan_purpose', null);
                                }}
                                options={options.loan_purpose}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors?.loan_purpose && errors?.loan_purpose?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                </div>
                <div className="p-3 flex max-md:flex-col">
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl font-bold text-gray">英文姓名</p>
                        <p className="text-xs text-gray1 mb-2">需與身份證上的名字相同</p>
                        <div className="flex border-b border-primary mb-2">
                            <p className="text-gray1 mb-2">姓氏：</p>
                            <input {...register('last_name', {
                                required: true,
                                onChange: (e) => {
                                    const value = alphabetOnly(e?.target?.value + '')
                                    console.log(value);
                                    setValue('last_name', value.toUpperCase())
                                }
                            })} className="flex-1 px-2 outline-none text-primary" placeholder="" />
                        </div>
                        {errors?.last_name && errors?.last_name?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                        <div className="flex border-b border-primary">
                            <p className="text-gray1 mb-2">名字：</p>
                            <input {...register('first_name', {
                                required: true,
                                onChange: (e) => {
                                    const value = alphabetOnly(e?.target?.value + '')
                                    setValue('first_name', capitalizeName(value))
                                }
                            })} className="flex-1 px-2 outline-none text-primary" placeholder="" />
                        </div>
                        {errors?.first_name && errors?.first_name?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <div className="relative">
                            <p className="text-xl text-gray mb-2 font-bold">性別</p>
                            <div className='flex space-x-10 max-md:justify-center'>
                                {options.genders.map(item => {
                                    return (
                                        <div {...register('gender', { required: true })} key={item.value} onClick={() => {
                                            setValue('gender', item.value);
                                            setGender(item.value)
                                            setError('gender', null);
                                        }} className={`w-24 h-12 cursor-pointer border text-gray1 border-primary rounded-md flex justify-center items-center ${gender === item.value ? 'bg-primary text-white' : 'bg-white'}`}>
                                            {item.label}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        {errors?.gender && errors?.gender?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                </div>
                <div className="p-3 flex max-md:flex-col">
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl font-bold text-gray mb-[22px]">香港身份證號碼</p>
                        <div className="flex items-center">
                            <input tabIndex={-1} maxLength={2} {...register('hkid1', {
                                required: true, onChange: (e) => {
                                    setValue('hkid1', alphabetOnly(e.target.value.toUpperCase().replace(' ', '')))
                                }
                            })} className="px-2 outline-none border-b text-primary w-1/3 text-center" placeholder="A" />
                            <input tabIndex={-1}
                                maxLength={6}
                                {...register('hkid2', { required: true })}
                                value={hkid2}
                                onChange={(e) => setHkid2(e.target.value.replace(/[^0-9]/g, ''))}
                                className="px-2 outline-none text-primary border-b w-full text-center ml-2 mr-2 border-primary"
                                placeholder="123456"
                            />
                            <div className="border-b border-primary text-center">
                                <span className="text-primary">(</span>
                                <input tabIndex={-1} maxLength={1} {...register('hkid3', {
                                    required: true,
                                    onChange: (e) => {
                                        setValue('hkid3', alphabetAndNumberOnly(e.target.value.toUpperCase().replace(' ', '')))
                                    }
                                })} className="px-1 outline-none text-primary w-3/4 text-center" placeholder="3" />
                                <span className="text-primary">)</span>
                            </div>
                        </div>
                        {(errors?.hkid1 || errors?.hkid2 || errors?.hkid3) &&
                            (errors?.hkid1?.type === 'required' || errors?.hkid2?.type === 'required' || errors?.hkid3?.type === 'required') && <span className="text-10 text-red-500">*必填</span>}
                        {(getValues('hkid1') && getValues('hkid2') && getValues('hkid3') && !checkId(getValues('hkid1'), getValues('hkid2'), getValues('hkid3'))) &&
                            (!(errors?.hkid1 || errors?.hkid2 || errors?.hkid3) ||
                                !(errors?.hkid1?.type === 'required' || errors?.hkid2?.type === 'required' || errors?.hkid3?.type === 'required')) && (
                                <span className="text-sm text-red-500">*請輸入正確的身份證號碼</span>
                            )}
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-xl text-gray mb-2">出生日期</p>
                        <Common.InputDate register={register} errors={errors} getValues={getValues} setValue={setValue} setError={setError} />
                    </div>
                </div>
                <div className="p-3 flex max-md:flex-col">
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl text-gray mb-2">手提電話</p>
                        <div className="flex items-center border-b border-primary">
                            <input maxLength={8} placeholder='(+852)' inputMode={'numeric'} {...register('phone_number',
                                {
                                    required: true,
                                    maxLength: 8,
                                    pattern: /^[0-9,]{8}$/,
                                    onChange: (e) => {
                                        setValue('phone_number', numberWithNoCommas(e?.target?.value))
                                        setError('phone_number', null)
                                    }
                                })} className="flex-1 px-2 outline-none w-full bg-white text-primary" />
                        </div>
                        {errors?.phone_number && errors?.phone_number?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                        {errors?.phone_number && errors?.phone_number?.type === 'pattern' && <span className="text-10 text-red-500">*請輸入正確的手提電話號碼</span>}
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-xl text-gray">電郵地址</p>
                        <Common.InputEmail register={register} setValue={setValue} onChange={(email) => setValue('email', email)} getValues={getValues} setError={setError} ></Common.InputEmail>
                        <input type='hidden' {...register('email', {
                            required: true,
                            pattern: /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\]\\.,;:\s@\\"]+\.)+[^<>()[\]\\.,;:\s@\\"]{2,})$/g,
                        })}
                        />
                        {errors?.email && errors?.email?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                        {errors.email && errors.email.type === 'pattern' && <span className="text-10 text-red-500">*請輸入正確的電郵</span>}
                    </div>
                </div>

                {/* 캡쳐 항목 주석 처리: 學歷 / 婚姻狀態
                <div className="p-3 flex max-md:flex-col">
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl text-gray mb-2">學歷</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('education', { required: true })}
                                onChange={(e) => {
                                    setValue('education', e.value);
                                    setError('education', null);
                                }}
                                options={options.education}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors?.education && errors?.education?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-xl text-gray mb-2">婚姻狀態</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('marriage_status', { required: true })}
                                onChange={(e) => {
                                    setValue('marriage_status', e.value);
                                    setError('marriage_status', null);
                                }}
                                options={options.marriage_status}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors?.marriage_status && errors?.marriage_status?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                </div>
                */}
                <div className="py-6 px-4 mt-9">
                    <div className="flex mb-2">
                        <input type="checkbox" {...register('checkbox1', {
                            required: true,
                            onChange: (e) => {
                                const checked = e.target.checked
                                if (checked) {
                                    setCheckBoxTime(prev => {
                                        return { ...prev, check_box_1_time: new Date() }
                                    })
                                }
                            }
                        })} id="id-checkbox1" className="mr-2 mt-1 w-5 h-5 peer relative appearance-none border border-primary rounded-md cursor-pointer checked:bg-primary" />
                        <label htmlFor="id-checkbox1" className="text-gray1 flex-1">
                            本人聲明本人
                            <span className="text-primary">並非破產中</span>
                            人士，而本人並無意申請破產及據本人所知現時並
                            <span className="text-primary">無任何有關本人破產呈請在進行中</span>。
                        </label>
                    </div>
                    <div className="flex">
                        <input type="checkbox" {...register('checkbox2', {
                            required: true,
                            onChange: (e) => {
                                const checked = e.target.checked
                                if (checked) {
                                    setCheckBoxTime(prev => {
                                        return { ...prev, check_box_2_time: new Date() }
                                    })
                                }
                            }
                        })} id="id-checkbox2" className="mr-2 mt-1 w-5 h-5 peer relative appearance-none border border-primary rounded-md cursor-pointer checked:bg-primary" />
                        <label htmlFor="id-checkbox2" className="text-gray1 flex-1">
                            本人確認為<span className="text-primary">香港永久性居民</span>並年齡為<span className="text-primary">18歲或以上人</span>士，本人已詳細閱讀並同意
                            <a href={`${process.env.REACT_APP_HOME_URL}/money-lenders-ordinance/`} className="text-primary underline" target="_blank" rel="noreferrer">
                                放債人條例
                            </a>
                            、
                            <a
                                href={`${process.env.REACT_APP_HOME_URL}/privacy-policy-and-personal-information-collection-statement/`}
                                className="text-primary underline"
                                target="_blank"
                                rel="noreferrer"
                            >
                                私隱政策及收集個人資料聲明
                            </a>
                            、
                            <a
                                href={`${process.env.REACT_APP_HOME_URL}/terms-and-conditions/`}
                                className="text-primary underline"
                                target="_blank"
                                rel="noreferrer"
                            >
                                私人貸款使用條款
                            </a>
                            及
                            <a href={`${process.env.REACT_APP_HOME_URL}/website-terms/`} className="text-primary underline" target="_blank" rel="noreferrer">
                                網站使用條款
                            </a>
                            ，亦同意 Cashing Pro Limited 有權向任何第三方人士索取有關本人的資料，包括向信貸資料機構查閱及提供本人的信貸記錄；亦同意 Cashing Pro Limited 經電話、短訊、WhatsApp、電子郵件通知本人有關貸款的服務信息。
                        </label>
                    </div>
                    {(errors.checkbox1 || errors.checkbox2) && (errors.checkbox1?.type === 'required' || errors.checkbox2?.type === 'required') && (
                        <span className="text-10 text-red-500">*請確認及勾選</span>
                    )}
                </div>
                {url?.is_show && <div className="px-3">
                    <a className="text-primary" href={url?.url}>{url.text}</a>
                </div>}
                <div className='flex space-x-2 justify-start items-end mt-9 p-3'>
                    <div>
                        <p className="text-xl text-gray mb-2">驗證碼</p>
                        <div className="flex items-center border-b border-primary">
                            <input maxLength={4} {...register('captcha_code', {
                                required: true,
                                onChange: (e) => {
                                    setValue('captcha_code', e.target?.value)
                                    setError('captcha_code', null)
                                }
                            })} className="flex-1 px-2 outline-none w-full bg-white text-primary" />
                            {((errors?.captcha_code && errors?.captcha_code?.type === 'required') || (!!getValues('captcha_code') && getValues('captcha_code')?.length === 4 && getValues('captcha_code') !== captcha)) && <span className="text-10 text-red-500">*驗證碼錯誤</span>}
                        </div>
                    </div>
                    <div className='flex justify-center items-center w-24 h-8 bg-gray2'>
                        <span className='tracking-[0.5rem] text-gray1 font-bold'>{captcha}</span>
                    </div>
                    <div className="cursor-pointer" onClick={() => setCaptcha(captchaRandom())}>
                        <img src={ReloadIcon} alt='' />
                    </div>
                </div>
                <div className="flex justify-center mt-9 mb-4">
                    <button disabled={isSubmitting} type="submit" className={`rounded-full text-white text-xl px-14 py-3 ${isSubmitting ? 'bg-mercury' : 'bg-primary'} button1`}>
                        第二步
                    </button>
                </div>
            </div>
        </form>
    );
}

export default StepForm1;
